// Session Storage key
export const SESSION_KEY_LOGIN_REDIRECT_PATH = 'loginRedirectPath';

// Cookie key
export const COOKIE_KEY_ACCESS_TOKEN = 'jwt_access_token';
export const COOKIE_KEY_REFRESH_TOKEN = 'jwt_refresh_token';
export const COOKIE_KEY_MS_ACCESS_TOKEN = 'ms_access_token';
export const COOKIE_KEY_MS_REFRESH_TOKEN = 'ms_refresh_token';

export const COOKIE_KEY_FIREBASE_TOKEN = 'firebase_token';
export const COOKIE_KEY_DISPLAY_TYPE = 'display_type';

export const COOKIE_KEY_TOKEN_SET = [
  COOKIE_KEY_ACCESS_TOKEN,
  COOKIE_KEY_REFRESH_TOKEN,
  COOKIE_KEY_MS_ACCESS_TOKEN,
  COOKIE_KEY_MS_REFRESH_TOKEN,
];
